// extracted by mini-css-extract-plugin
export default {"wrapper":"adminTabListItem_wrapper__bb6ZX","title":"adminTabListItem_title__vMOPC","activeTab":"adminTabListItem_activeTab__XrZ2a"};